import React, {useRef} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";

import {setShowJobEditPopup} from "../../../actions/A_Popups";
import JobEditPopupContent from "./JobEditPopupContent";
import JobEditPopupHeader from "./JobEditPopupHeader";
import JobEditIframe from "./JobEditIframe";
import JobEditPopupContext from "./JobEditPopupContext";
import JobEditPopupInfoBar from "./JobEditPopupInfoBar";


const JobEditPopup = (props) => {

  const {setShowJobEditPopup, jobEditPopupIframeLoading, intl} = props;

  const iframeElement = useRef();

  const closePopup = () => {
    setShowJobEditPopup(false);
  };

  return (
    <JobEditPopupContext.Provider value={{iframeElement: iframeElement.current}}>
      <div className="ui-popup ui-popup--common flex flex--column">
        <button className="ui-popup-header__close w-15 h-15" onClick={closePopup}/>
        <div className="mt-1 mb-1 pl-15 pr-15">
          <h3 className="mt-0 mb-025 color-blue regular">
            <FormattedMessage id="jobBoard.editPopup.title"/>
          </h3>
          <h4 className="font--15 color-gray4 regular m-0">
            <FormattedMessage id="jobBoard.editPopup.subTitle"/>
          </h4>
        </div>
        {jobEditPopupIframeLoading ? null : <JobEditPopupHeader/>}
        {jobEditPopupIframeLoading ? null : <JobEditPopupInfoBar/>}
        <JobEditIframe ref={iframeElement} intl={intl}/>
        <div className="pl-15 pr-075 flex-item scrollbar3 mr-075">
          {jobEditPopupIframeLoading ? <div className="ui-loader ui-loader--medium"/> : <JobEditPopupContent/>}
        </div>
        <div className="ui-popup-footer">
          <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--blue" onClick={closePopup}>
            <FormattedMessage id="messageBox.buttons.cancel"/>
          </button>
          <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--green" onClick={null}>
            <FormattedMessage id="messageBox.buttons.update"/>
          </button>
        </div>
      </div>
    </JobEditPopupContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {showJobPaymentPopup} = store.popups;
  const {jobEditPopupIframeLoading} = store.jobEditPopupState;

  return {
    showJobPaymentPopup,
    jobEditPopupIframeLoading,
  };
};

const mapDispatchToProps = {
  setShowJobEditPopup,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobEditPopup)
)
